<template>
    <section class="container">
        <div class="d-flex justify-content-center">
            <img src="https://beneat.s3.ap-southeast-1.amazonaws.com/images/irobot_survey.jpg" :width="$mq.phone? '350':'500'" alt="...">
        </div>
        <template v-if="isCompleted">
            <div class="text-center mt-4">
                <h2>ขอบคุณที่ลงทะเบียน</h2>
                <p>BeNeat ขอขอบคุณท่านที่ให้ความสนใจเข้าร่วมโครงการ จะมีทางเจ้าหน้าที่ติดต่อท่านเพื่อยืนยันการเข้าร่วมกิจกรรมล่วงหน้า 1 วัน</p>
            </div>
        </template>
        <template v-else>

            <div class="text-center mt-4">
                <template v-if="$mq.phone">
                    <h3>แบบฟอร์มลงทะเบียนเข้าร่วมกิจกรรม Workshop<br>BeNeat x iRobot<br>(สะอาด x 2 เพื่อบ้านสะอาดที่สุด)</h3>
                </template>
                <template v-else>
                    <h2>แบบฟอร์มลงทะเบียนเข้าร่วมกิจกรรม Workshop<br>BeNeat x iRobot<br>(สะอาด x 2 เพื่อบ้านสะอาดที่สุด)</h2>
                </template>
            </div>
            <div>
                <form data-vv-scope="irobot" @submit.prevent="formSubmit()">
                    <div class="form-group">
                        <label><span class="text-danger mr-1">*</span>ชื่อ-นามสกุล</label>
                        <input type="text"
                                class="form-control input-jumbo"
                                :class="{'form-alert': errors.has('irobot.name')}"
                                :style="$mq.phone ? '' : 'width:40%'"
                                id="name"
                                name="name"
                                v-model="form.name"
                                v-validate="'required'"
                                >
                        <div class="mt-1 text-remark -status-alert" v-if="errors.has('irobot.name')">
                            {{ $t('message.required_field') }}
                        </div>
                    </div>
                    <div class="form-group">
                        <label><span class="text-danger mr-1">*</span>หมายเลขโทรศัพท์</label>
                        <input type="number"
                                class="form-control input-jumbo"
                                :class="{'form-alert': errors.has('irobot.tel')}"
                                :style="$mq.phone ? '' : 'width:40%'"
                                id="tel"
                                name="tel"
                                v-model="form.tel"
                                v-validate="'required'"
                                >
                        <div class="mt-1 text-remark -status-alert" v-if="errors.has('irobot.tel')">
                            {{ $t('message.required_field') }}
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="workshop_date"><span class="text-danger mr-1">*</span>วันที่ต้องการเข้าร่วม</label>
                        <div class="row no-gutters pl-2">
                            <div class="exp col-12">
                                <div class="checkbox">
                                  <input type="radio"
                                         name="workshop_date"
                                         id="workshop_date_1"
                                         value="2024-10-19"
                                         v-validate="'required'"
                                         v-model="form.workshop_date"/>
                                  <label class="mb-3" for="workshop_date_1">
                                    <span> </span>
                                    19 ตุลาคม 2567
                                  </label>
                                </div>
                            </div>
                            <div class="exp col-12">
                                <div class="checkbox">
                                  <input type="radio"
                                         name="workshop_date"
                                         id="workshop_date_2"
                                         value="2024-10-19"
                                         v-validate="'required'"
                                         v-model="form.workshop_date"/>
                                  <label class="mb-3" for="workshop_date_2">
                                    <span> </span>
                                    20 ตุลาคม 2567
                                  </label>
                                </div>
                            </div>
                        </div>
                        <div class="mt-1 text-remark -status-alert" v-if="errors.has('irobot.workshop_date')">
                            {{ $t('message.required_field') }}
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="workshop_time"><span class="text-danger mr-1">*</span>รอบที่ต้องการเข้าร่วม</label>
                        <div class="row no-gutters pl-2">
                            <div class="exp col-12">
                                <div class="checkbox">
                                  <input type="radio"
                                         name="workshop_time"
                                         id="workshop_time_1"
                                         value="10:30 - 12:00"
                                         v-validate="'required'"
                                         v-model="form.workshop_time"/>
                                  <label class="mb-3" for="workshop_time_1">
                                    <span> </span>
                                    ช่วงเข้า 10:30 - 12:00 น.
                                  </label>
                                </div>
                            </div>
                            <div class="exp col-12">
                                <div class="checkbox">
                                  <input type="radio"
                                         name="workshop_time"
                                         id="workshop_time_2"
                                         value="14:00 - 15:30"
                                         v-validate="'required'"
                                         v-model="form.workshop_time"/>
                                  <label class="mb-3" for="workshop_time_2">
                                    <span> </span>
                                    ช่วงบ่าย 14:00 - 15:30 น.
                                  </label>
                                </div>
                            </div>
                        </div>
                        <div class="mt-1 text-remark -status-alert" v-if="errors.has('irobot.workshop_time')">
                            {{ $t('message.required_field') }}
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="number_of_paticipants"><span class="text-danger mr-1">*</span>ที่นั่งในแต่ละรอบมีจำนวนจำกัด โปรดระบุจำนวนผู้เข้าร่วม (รวมตัวท่าน)</label>
                        <div class="row no-gutters pl-2">
                            <div class="exp col-12">
                                <div class="checkbox">
                                  <input type="radio"
                                         name="number_of_paticipants"
                                         id="number_of_paticipants_1"
                                         value="1"
                                         v-validate="'required'"
                                         v-model="form.number_of_paticipants"/>
                                  <label class="mb-3" for="number_of_paticipants_1">
                                    <span> </span>
                                    1 ท่าน
                                  </label>
                                </div>
                            </div>
                            <div class="exp col-12">
                                <div class="checkbox">
                                  <input type="radio"
                                         name="number_of_paticipants"
                                         id="number_of_paticipants_2"
                                         value="2"
                                         v-validate="'required'"
                                         v-model="form.number_of_paticipants"/>
                                  <label class="mb-3" for="number_of_paticipants_2">
                                    <span> </span>
                                    2 ท่าน
                                  </label>
                                </div>
                            </div>
                            <div class="exp col-12">
                                <div class="checkbox">
                                  <input type="radio"
                                         name="number_of_paticipants"
                                         id="number_of_paticipants_3"
                                         value="3"
                                         v-validate="'required'"
                                         v-model="form.number_of_paticipants"/>
                                  <label class="mb-3" for="number_of_paticipants_3">
                                    <span> </span>
                                    3 ท่าน
                                  </label>
                                </div>
                            </div>
                        </div>
                        <div class="mt-1 text-remark -status-alert" v-if="errors.has('irobot.number_of_paticipants')">
                            {{ $t('message.required_field') }}
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="irobot_usage_status"><span class="text-danger mr-1">*</span>ที่นั่งในแต่ละรอบมีจำนวนจำกัด โปรดระบุจำนวนผู้เข้าร่วม (รวมตัวท่าน)</label>
                        <div class="row no-gutters pl-2">
                            <div class="exp col-12">
                                <div class="checkbox">
                                  <input type="radio"
                                         name="irobot_usage_status"
                                         id="irobot_usage_status_1"
                                         value="1"
                                         v-validate="'required'"
                                         v-model="form.irobot_usage_status"/>
                                  <label class="mb-3" for="irobot_usage_status_1">
                                    <span> </span>
                                    ปัจจุบันใช้ iRobot
                                  </label>
                                </div>
                            </div>
                            <div class="exp col-12">
                                <div class="checkbox">
                                  <input type="radio"
                                         name="irobot_usage_status"
                                         id="irobot_usage_status_2"
                                         value="2"
                                         v-validate="'required'"
                                         v-model="form.irobot_usage_status"/>
                                  <label class="mb-3" for="irobot_usage_status_2">
                                    <span> </span>
                                    ไม่เคยใช้ iRobot
                                  </label>
                                </div>
                            </div>
                            <div class="exp col-12">
                                <div class="checkbox">
                                  <input type="radio"
                                         name="irobot_usage_status"
                                         id="irobot_usage_status_3"
                                         value="3"
                                         v-validate="'required'"
                                         v-model="form.irobot_usage_status"/>
                                  <label class="mb-3" for="irobot_usage_status_3">
                                    <span> </span>
                                    เคยทดลองใช้ iRobot แต่ไม่ได้ใช้แล้ว
                                  </label>
                                </div>
                            </div>
                            <div class="exp col-12">
                                <div class="checkbox">
                                  <input type="radio"
                                         name="irobot_usage_status"
                                         id="irobot_usage_status_4"
                                         value="4"
                                         v-validate="'required'"
                                         v-model="form.irobot_usage_status"/>
                                  <label class="mb-3" for="irobot_usage_status_4">
                                    <span> </span>
                                    อื่น ๆ โปรดระบุ…
                                  </label>
                                </div>
                            </div>
                        </div>
                        <div v-if="Number(form.irobot_usage_status) === 4">
                            <input type="text"
                                    class="form-control"
                                    :class="{'form-alert': errors.has('irobot.irobot_usage_status_other')}"
                                    :style="$mq.phone ? '' : 'width:40%'"
                                    id="irobot_usage_status_other"
                                    name="irobot_usage_status_other"
                                    v-model="form.irobot_usage_status_other"
                                    v-validate="'required'" />
                        </div>
                        <div class="mt-1 text-remark -status-alert" v-if="errors.has('irobot.irobot_usage_status')">
                            {{ $t('message.required_field') }}
                        </div>
                        <div class="mt-1 text-remark -status-alert" v-if="errors.has('irobot.irobot_usage_status_other')">
                            {{ $t('message.required_field') }}
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="gender"><span class="text-danger mr-1">*</span>เพศ (Gender)</label>
                        <div class="row no-gutters pl-2">
                            <div class="exp col-12">
                                <div class="checkbox">
                                  <input type="radio"
                                         name="gender"
                                         id="man"
                                         value="เพศชาย"
                                         v-validate="'required'"
                                         v-model="form.gender"/>
                                  <label class="mb-3" for="man">
                                    <span> </span>
                                    เพศชาย (Male)
                                  </label>
                                </div>
                            </div>
                            <div class="exp col-12">
                                <div class="checkbox">
                                  <input type="radio"
                                         name="gender"
                                         id="women"
                                         value="เพศหญิง"
                                         v-validate="'required'"
                                         v-model="form.gender"/>
                                  <label class="mb-3" for="women">
                                    <span> </span>
                                    เพศหญิง (Female)
                                  </label>
                                </div>
                            </div>
                            <div class="exp col-12">
                                <div class="checkbox">
                                  <input type="radio"
                                         name="gender"
                                         id="other"
                                         value="other"
                                         v-validate="'required'"
                                         v-model="form.gender"/>
                                  <label class="mb-3" for="other">
                                    <span> </span>
                                    ไม่ระบุ (Other)
                                  </label>
                                </div>
                            </div>
                        </div>
                        <div class="mt-1 text-remark -status-alert" v-if="errors.has('irobot.gender')">
                            {{ $t('message.required_field') }}
                        </div>
                    </div>
                    <div class="form-group">
                        <label><span class="text-danger mr-1">*</span>อายุ (Age)</label>
                        <div class="row no-gutters pl-2">
                            <div class="exp col-12">
                                <div class="checkbox">
                                    <input type="radio"
                                            name="age"
                                            id="age_20_30"
                                            value="20-30"
                                            v-validate="'required'"
                                            v-model="form.age"/>
                                    <label class="mb-3" for="age_20_30">
                                    <span> </span>
                                    20 - 30 ปี
                                    </label>
                                </div>
                            </div>
                            <div class="exp col-12">
                                <div class="checkbox">
                                    <input type="radio"
                                            name="age"
                                            id="age_31_40"
                                            value="31-40"
                                            v-validate="'required'"
                                            v-model="form.age"/>
                                    <label class="mb-3" for="age_31_40">
                                    <span> </span>
                                    31 - 40 ปี
                                    </label>
                                </div>
                            </div>
                            <div class="exp col-12">
                                <div class="checkbox">
                                    <input type="radio"
                                            name="age"
                                            id="age_41_50"
                                            value="41-50"
                                            v-validate="'required'"
                                            v-model="form.age"/>
                                    <label class="mb-3" for="age_41_50">
                                    <span> </span>
                                    41 - 50 ปี
                                    </label>
                                </div>
                            </div>
                            <div class="exp col-12">
                                <div class="checkbox">
                                    <input type="radio"
                                            name="age"
                                            id="age_51_60"
                                            value="51-60"
                                            v-validate="'required'"
                                            v-model="form.age"/>
                                    <label class="mb-3" for="age_51_60">
                                    <span> </span>
                                    51 - 60 ปี
                                    </label>
                                </div>
                            </div>
                            <div class="exp col-12">
                                <div class="checkbox">
                                    <input type="radio"
                                            name="age"
                                            id="age_61"
                                            value="61"
                                            v-validate="'required'"
                                            v-model="form.age"/>
                                    <label class="mb-3" for="age_61">
                                    <span> </span>
                                    มากกว่า 61 ปี
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="mt-1 text-remark -status-alert" v-if="errors.has('irobot.age')">
                            {{ $t('message.required_field') }}
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="salary">รายได้เฉลี่ยต่อเดือน (Average monthly income)</label>
                        <div class="row no-gutters pl-2">
                            <div class="exp col-12">
                                <div class="checkbox">
                                  <input type="radio"
                                         name="salary"
                                         id="s_15_20"
                                         value="15000-20000"
                                         v-model="form.salary"/>
                                  <label class="mb-3" for="s_15_20">
                                    <span> </span>
                                    15,000 - 20,000 บาท
                                  </label>
                                </div>
                            </div>
                            <div class="exp col-12">
                                <div class="checkbox">
                                  <input type="radio"
                                         name="salary"
                                         id="s_20_30"
                                         value="20001-30000"
                                         v-model="form.salary"/>
                                  <label class="mb-3" for="s_20_30">
                                    <span> </span>
                                    20,001 - 30,000 บาท
                                  </label>
                                </div>
                            </div>
                            <div class="exp col-12">
                                <div class="checkbox">
                                  <input type="radio"
                                         name="salary"
                                         id="s_30_40"
                                         value="30001-40000"
                                         v-model="form.salary"/>
                                  <label class="mb-3" for="s_30_40">
                                    <span> </span>
                                    30,001 - 40,000 บาท
                                  </label>
                                </div>
                            </div>
                            <div class="exp col-12">
                                <div class="checkbox">
                                  <input type="radio"
                                         name="salary"
                                         id="s_40_50"
                                         value="40001-50000"
                                         v-model="form.salary"/>
                                  <label class="mb-3" for="s_40_50">
                                    <span> </span>
                                    40,001 - 50,000 บาท
                                  </label>
                                </div>
                            </div>
                            <div class="exp col-12">
                                <div class="checkbox">
                                  <input type="radio"
                                         name="salary"
                                         id="s_50"
                                         value="50001"
                                         v-model="form.salary"/>
                                  <label class="mb-3" for="s_50">
                                    <span> </span>
                                    มากกว่า 50,000 บาท
                                  </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <span class="text-danger">* จะมีทางเจ้าหน้าที่ติดต่อท่าน เพื่อยืนยันการเข้าร่วมกิจกรรมล่วงหน้า 1 วันนะคะ</span>
                    </div>
                    <div class="text-center pb-5 mt-2">
                        <button type="submit" class="btn btn__submit btn-lg px-5 mt-3">
                            Submit
                        </button>
                    </div>
                </form>
            </div>
        </template>
    </section>
</template>
<script>
import axios from 'axios'
export default {
  data: () => ({
    form: {
      name: null,
      tel: null,
      gender: null,
      age: null,
      salary: null,
      admin_id: null,
      workshop_date: null,
      workshop_time: null,
      irobot_usage_status: null,
      number_of_paticipants: null
    },
    isCompleted: false
  }),
  methods: {
    formSubmit () {
      this.$validator.validate().then(valid => {
        if (valid) {
          this.save()
        }
      })
    },
    async save () {
      this.form.user_id = this.$route.query.user_id
      const { data } = await axios.post('/surveys/form/4', {
        user_id: this.$route.query.user_id,
        data: this.form,
        type: 'survey_4'
      })
      if (!data.error) {
        // this.$swal({
        //   type: 'success',
        //   title: 'ลงทะเบียนสำเร็จ',
        //   text: 'BeNeat ขอขอบคุณท่านที่ให้ความสนใจเข้าร่วมโครงการ จะมีทางเจ้าหน้าที่ติดต่อท่าน เพื่อยืนยันการเข้าร่วมกิจกรรมล่วงหน้า 1 วัน',
        //   showConfirmButton: false,
        //   showCloseButton: true
        // })
        this.isCompleted = true
        window.scrollTo(0, 0)
      } else {
        this.$swal({
          type: 'error',
          title: 'เกิดข้อผิดพลาด',
          text: 'กรุณาลองใหม่อีกครั้ง',
          showConfirmButton: false,
          showCloseButton: true
        })
      }
    }
  }
}
</script>
<style scoped>
.btn__submit {
    background-color: #3cc1d8;
    color: white;
}
</style>


// WEBPACK FOOTER //
// src/components/survey/IRobotSurvey.vue